import { ActionButtonProps } from '../../../action-button/types';

const { appearance, size, format, ...props } = ActionButtonProps;

export const DialogHeaderActionButtonProps = props;
